import { render, staticRenderFns } from "./CadastroTipoAlta.vue?vue&type=template&id=78023b95&"
import script from "./CadastroTipoAlta.vue?vue&type=script&lang=js&"
export * from "./CadastroTipoAlta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports